module.exports = __webpack_public_path__ + "static/100--stacked-bar-394cbcbbe4c2923ea61c072cde28b198.png";